/* @ngInject */
const myModifPosition = (
  utils,
  valueHandler,
  $timeout,
  $state,
  $$railway,
  toaster,
  $$wagon
) => {
  return {
    restrict: 'E',
    scope: {
      myWagon: '=',
      myRailway: '=',
      myFields: '=',
    },

    template: require('./myModifPosition.html'),

    /* @ngInject */
    controller: ($scope) => {
      $scope.utils = utils

      $scope.modifyPosition = async (_wagonIds, _railwayId) => {
        if (!valueHandler.isId(_railwayId)) {
          _railwayId = await $$railway.local.getCurrentId()
        }

        try {
          const message = await $$wagon.request.modifyPosition(_wagonIds, _railwayId)
          toaster.message(message)
          $state.reload()
        } catch (error) {
          toaster.error(error)
        }
      }

      $scope.isOk = true

      const sortNumber = (a, b) => {
        return a - b
      }

      $scope.isPositionsOk = (_positions) => {
        $timeout(() => {
          const pos = []
          for (const wagonId in _positions) {
            if (!valueHandler.isNull(_positions[wagonId])) {
              pos.push(_positions[wagonId])
            }
          }
          pos.sort(sortNumber)
          for (let i = 0; i < pos.length; i++) {
            if (pos[i] !== (i + 1)) {
              if (pos[i] === i) {
                $scope.helpMessage = 'La position ' + (i) + ' est présente plusieurs fois'
              } else {
                $scope.helpMessage = 'La position ' + (i + 1) + ' est manquante'
              }
              $scope.isOk = false
              return false
            }
          }
          $scope.helpMessage = ''
          $scope.isOk = true
          return true
        })
      }

      $scope.reverse = false
      $scope.propertyName = 'position'
      $scope.sortBy = (_propertyName) => {
        $scope.reverse = ($scope.propertyName === _propertyName) ? !$scope.reverse : false
        $scope.propertyName = _propertyName
      }
    },

    link: (scope, element, attrs) => {

    },
  }
}

export default myModifPosition



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/tables/myModifPosition.js